import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastController } from '@ionic/angular';

import { Observable } from 'rxjs';
import { PouchService } from '../services/pouch-service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(public db: PouchService, public router: Router, public toastController: ToastController) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.db.defaultDB) {
      this.db.credentials = JSON.parse(localStorage.getItem(this.db.appinfo?.product + '_credentials'));
    }
    this.db.analytics.page({
      url: `https://apps.sarutech.com/${this.db?.appinfo?.product}${state.url}`,
      title: `${this.db.appinfo.product.toUpperCase()} - ${state.url.split('/')[1]}`,
    });
    if (state.url == '/SignupPage' || ((state.url == '/AddPaymentPage' || state.url == '/ActivateOfflinePage') && this.db.gsetting.username)) {
      return true;
    } else if (this.db.credentials == undefined || this.db.credentials == null) {
      this.router.navigateByUrl('/LoginPage');
      return false;
    } else {
      if (state.url == '/LoginPage') {
        // Make Sure to Logout of database before getting to DB Login Page
        if (localStorage.getItem(this.db.appinfo.product + '_credentials') != null) {
          localStorage.removeItem(this.db.appinfo.product + '_credentials');
        }
        return true;
      } else if (state.url == '/LoginUserPage') {
        // Make sure to Logout of User Account Before getting to Login User Page
        if (localStorage.getItem(this.db.appinfo.product + '_user') != null) {
          localStorage.removeItem(this.db.appinfo.product + '_user');
        }
        return true;
      } else if (state.url == '/PreloadPage' && !this.db.preloaded) {
        if (localStorage.getItem(this.db.appinfo.product + '_credentials') == null) {
          //Check if database login
          this.router.navigateByUrl('/LoginPage');
          return false;
        } else if (localStorage.getItem(this.db.appinfo.product + '_user') == null) {
          //Check if user login
          this.router.navigateByUrl('/LoginUserPage', {
            state: { start: true },
          });
          return false;
        } else {
          // Initialize currently loggedin user in pouch Service
          let _user = localStorage.getItem(this.db.appinfo.product + '_user');
          if (!_user || _user == 'undefined') {
            this.router.navigateByUrl('/LoginUserPage', {
              state: { start: true },
            });
            return false;
          } else {
            this.db.user = JSON.parse(_user);
          }
          if (this.db.gsetting?.plans) {
            this.db.analytics.identify(this.db.user?.id, {
              name: this.db.user?.fullname,
              company: this.db.gsetting?.company,
              plan: this.db.gsetting?.plans[this.db.gsetting?.plans.length - 1],
            });
          }
          return true;
        }
      } else if (!this.db.preloaded) {
        //Ensure App is preloaded before jumping in (Later we can optimize preload not to check everything)
        this.router.navigateByUrl('/PreloadPage', {
          skipLocationChange: true,
        });
        return false;
      } else {
        if (this.db.user_roles && this.db.user_roles.pages && this.db.user_roles.pages[state.url] == false) {
          this.presentToast('You do not have permission to view this page', 'toast-danger');
          return false;
        } else {
          return true;
        }
      }
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }
}
